import { useEffect } from 'react';
import { gql, useLazyQuery } from '@apollo/client';
import { AppId } from '@skytvnz/sky-app-store/lib/types/graph-ql';
import { updatePackageCacheData } from '@/Utils/Puj';

export const GET_ACTIVE_PKGS_WITH_DETAILS = gql(/* GraphQL */ `
  query GetActivePkgsWithDetails($appId: AppId!) {
    experience(appId: $appId) {
      customer {
        packages {
          package {
            image {
              uri
            }
            title
            mySubscription {
              price {
                basePrice {
                  amount
                }
                billingFrequency
              }
            }
          }
        }
      }
    }
  }
`);

export const CUSTOMER_ACTIVE_PACKAGE_EVENT_SUBSCRIPTION = gql(/* GraphQL */ `
  subscription customerActPkgEventSubscription($appId: AppId!) {
    customerAccount(appId: $appId) {
      account {
        packages {
          package {
            id
            image {
              uri
            }
            title
            mySubscription {
              price {
                basePrice {
                  amount
                }
                billingFrequency
              }
            }
          }
        }
      }
    }
  }
`);

const useActivePackages = (subscribeToChanges: boolean) => {
  const [getActivePkgs, result] = useLazyQuery(GET_ACTIVE_PKGS_WITH_DETAILS);

  const getActivePackages = () => {
    getActivePkgs({ variables: { appId: AppId.SkyGoWeb } });
  };

  useEffect(() => {
    let unsubscribe: (() => void) | null = null;

    if (subscribeToChanges && result.data && result.subscribeToMore) {
      unsubscribe = result.subscribeToMore({
        document: CUSTOMER_ACTIVE_PACKAGE_EVENT_SUBSCRIPTION,
        variables: { appId: AppId.SkyGoWeb },
        updateQuery: (prev, { subscriptionData }) => updatePackageCacheData(prev, subscriptionData),
      });
    }

    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [subscribeToChanges, result]);

  return { getActivePackages, result };
};
export default useActivePackages;
